import { render, staticRenderFns } from "./home_help.vue?vue&type=template&id=03b25f3a&scoped=true"
import script from "./home_help.vue?vue&type=script&lang=js"
export * from "./home_help.vue?vue&type=script&lang=js"
import style0 from "./home_help.vue?vue&type=style&index=0&id=03b25f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b25f3a",
  null
  
)

export default component.exports